// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p_1EJ{margin-bottom:13px;padding:0 3rem;position:relative}.O_esB{border-radius:.4rem;height:20px;height:2rem;left:0;position:absolute;width:20px;width:2rem}.kO3Ot{color:#0a385a;font-size:14px;font-size:1.4rem;font-weight:700;line-height:18px;line-height:1.8rem;max-width:200px;overflow:hidden;text-align:center;text-overflow:ellipsis;white-space:break-spaces}.kO3Ot:first-letter{text-transform:capitalize}", ""]);
// Exports
exports.locals = {
	"tooltipTitle": "p_1EJ",
	"tooltipTitle__snaqIcon": "O_esB",
	"tooltipTitle__titleText": "kO3Ot"
};
module.exports = exports;
